export default Object.freeze({
  CANCELLED: 2,
  GETTING_READY: 3,
  CARRIER_PAYMENT_COMPLETED: 12,
  PACKING: 22,
  CHECKING: 23,
});
